import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { getLeadScoreColor } from '../Utility/constant';

const LeadScoreBar = ({ score }) => {
  if (score == null) {
    return (
      <Typography variant="body2" sx={{ color: 'text.disabled', lineHeight: '36px' }}>
        —
      </Typography>
    );
  }

  const color = getLeadScoreColor(score);
  // Clamp between 0 and 100 just in case
  const normalised = Math.min(100, Math.max(0, score));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        gap: '2px',
        py: '4px',
      }}
    >
      {/* Score label */}
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          fontSize: '12px',
          color: color,
          lineHeight: 1.2,
        }}
      >
        {normalised}%
      </Typography>

      {/* Colored progress bar */}
      <LinearProgress
        variant="determinate"
        value={normalised}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: `${color}30`,   // 19% opacity background track
          '& .MuiLinearProgress-bar': {
            backgroundColor: color,
            borderRadius: 3,
          },
        }}
      />
    </Box>
  );
};

export default LeadScoreBar;
